import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import { LOCATION_RULES_FETCH, LOCATION_RULES_FETCH_MORE, LOCATION_VIEWED_SET, LOCATIONS_FETCH } from '../action-types';
import { IEntitiesState } from '../shared/entities/entities-state';
import { ILocationsState, initialLocationsState } from './locations-state';
import { GROUP_LOCATION, GROUP_LOCATION_RULES } from '../state-groups';
import { reducer as listReducer } from '../shared/list/reducer';

export function reducer(state = initialLocationsState(), action: any, entitySlice: IEntitiesState): ILocationsState {
    
    switch (action.type) {

        case LOCATIONS_FETCH:

            return {
                ...state,
                companyLocations: {
                    ...state.companyLocations,
                    isFetching: true
                }
            };

        case LOCATION_RULES_FETCH:
            return {
                ...state,
                locationRules: { ...state.locationRules, isFetching: true }
            };

        case LOCATION_RULES_FETCH_MORE:
            return {
                ...state,
                locationRules: { ...state.locationRules, isFetchingMore: true }
            };

        case LOCATION_VIEWED_SET:
            return {
                ...state,
                viewedLocationId: action.payload.locationId
            };

        default:
            let nextState: ILocationsState = state;

            if (isActionRelated(action, [GROUP_LOCATION, GROUP_LOCATION_RULES])) {
                nextState = {
                    ...state,
                    companyLocations: createNamedWrapperReducer(listReducer, GROUP_LOCATION)(state.companyLocations, action, entitySlice.entities),
                    locationRules: createNamedWrapperReducer(listReducer, GROUP_LOCATION_RULES)(state.locationRules, action, entitySlice.entities),
                };
            }

            return nextState;
    }
}